"use client";

import React, { useEffect, useState } from "react";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import Link from "next/link";
import { useMediaQuery, useTheme } from "@mui/material";

interface HelpCircleProps {
  lang: string;
  slug: string;
}

const HelpCircle: React.FC<HelpCircleProps> = ({ lang, slug }) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  const theme = useTheme();

  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 30 && isDesktop);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isDesktop]);

  return (
    isVisible && (
      <div className="ease fixed bottom-[150px] right-[15px] z-[1000] transition-opacity duration-300 sm:right-[20px] md:bottom-[100px]">
        <Link
          href={`/${lang}/information/${slug}`}
          prefetch={false}
          aria-label="help"
          className="flex h-10 w-10 items-center justify-center rounded-full bg-primary hover:bg-black"
        >
          <QuestionMarkIcon sx={{ fill: "#fff", fontSize: "20px" }} />
        </Link>
      </div>
    )
  );
};

export default React.memo(HelpCircle);
